import { LabelValue } from "@shared/models/label-value.interface";
import {
  AutoComplete,
  AutoCompleteCompleteEvent,
} from "primereact/autocomplete";
import { useCallback, useState } from "react";

import { GetResponseAgentModel } from "../../../factory/model/query-model-agent";
import { useQyGetAgent } from "../../../factory/query/agent.query";

export function useAutocompleteAgent(
  defaultValue: string | null,
  name: string,
  label: string,
  hint: string,
  onAutocompleteSelect: (selectedAgent: any | null) => void
) {
  const [value, setValue] = useState<LabelValue>();
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState<LabelValue[]>([]);
  const [enabledGet, setEnabledGet] = useState(true);

  // QUERY
  const handleSuggestions = (response: GetResponseAgentModel) => {
    const mappedSuggestions = (response?.data || [])
      .map(
        (item) =>
          ({
            label: `${item.name}`,
            value: item.code,
            payload: item.markup_percentage,
          } as LabelValue)
      )
      .filter((x) => !!x.label);
    setSuggestions(mappedSuggestions);
    if (defaultValue) {
      const matchedObject = mappedSuggestions.find(
        (item) => item.value === defaultValue
      );
      setValue(matchedObject);
    }
  };
  useQyGetAgent(
    searchTerm,
    999999,
    0,
    undefined,
    undefined,
    enabledGet,
    handleSuggestions
  );

  // LOCAL
  const onSearch = useCallback(
    (term: AutoCompleteCompleteEvent) => {
      setSearchTerm(term.query);
      setEnabledGet(true);
    },
    [setSearchTerm, setEnabledGet]
  );
  const handleSelect = useCallback(
    (selected: LabelValue) => {
      setValue(selected);
      onAutocompleteSelect(selected);
    },
    [setValue, onAutocompleteSelect]
  );

  // HTML
  const formElement = (
    <div
      id="AutocompleteAgent"
      className="autocomplete-person person field mt-5"
    >
      <span className="p-float-label">
        <AutoComplete
          id={name}
          field="label"
          inputClassName="w-full"
          className="w-full md:w-3/4"
          // placeholder="Type to find a person"
          value={value}
          suggestions={suggestions}
          onChange={(e) => {
            handleSelect(e.value);
          }}
          completeMethod={onSearch}
        />
        <label className="text-xs text-gray-500" htmlFor={name}>
          {label}
        </label>
      </span>
      <small className="text-gray-400 mb-1 italic">{hint}</small>
    </div>
  );

  return {
    formElement,
  };
}

export default useAutocompleteAgent;
